import { faCircleXmark, faRobot, faUpload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from 'aa_common/front-end/antd'
import { If } from 'aa_common/front-end/components'
import { Divider, Form, Image, Input, Upload } from 'antd'
import { CSRF_TOKEN_KEY, IMAGE_UPLOAD_PATH } from 'common/constants'
import { getNs } from 'common/i18n-config'

import { AIState } from '../hooks/use-ai-suggestion-handlers'
import { AIFormContentWrapper, ImageWrapper } from '../styles'

const { Dragger } = Upload
const { t, useNsReady } = getNs(['components/organisms/assets/asset-form'])

export const AIFormContent = ({
  aiState,
  setAIState,
  onSubmit,
  showRunAIAnalysisButton,
}: {
  aiState: AIState
  setAIState: (aiState: AIState) => void
  onSubmit: () => void
  showRunAIAnalysisButton?: boolean
}) => {
  useNsReady()

  const headers: any = {
    'X-CSRF-Token': localStorage.getItem(CSRF_TOKEN_KEY),
  }

  return (
    <AIFormContentWrapper>
      <Form layout="vertical">
        <Form.Item label={t('enter_asset_name')}>
          <Input
            placeholder={t('enter_asset_name_placeholder')}
            maxLength={100}
            value={aiState?.assetName}
            onChange={e => setAIState({ ...aiState, assetName: e.target.value })}
          />
        </Form.Item>
        <Divider plain>{t('or')}</Divider>
        <Form.Item label={t('upload_an_image')}>
          <If condition={!aiState?.image?.url}>
            <Dragger
              withCredentials
              accept="image/*"
              action={IMAGE_UPLOAD_PATH}
              headers={headers}
              onChange={({ file }) => {
                if (file?.response) {
                  setAIState({
                    ...aiState,
                    image: file?.response?.data,
                  })
                }
              }}
            >
              <p className="ant-upload-drag-icon">
                <FontAwesomeIcon icon={faUpload} style={{ color: '#3b7de9', fontSize: 32 }} />
              </p>
              <p className="ant-upload-text">{t('upload_an_image_2')}</p>
            </Dragger>
          </If>
          <If condition={Boolean(aiState?.image?.url)}>
            <div style={{ textAlign: 'center' }}>
              <ImageWrapper>
                <Image width={200} src={aiState?.image?.url} alt={aiState?.image?.filename ?? ''} />
                <FontAwesomeIcon icon={faCircleXmark} onClick={() => setAIState({ ...aiState, image: undefined })} />
              </ImageWrapper>
            </div>
          </If>
        </Form.Item>
        <If condition={showRunAIAnalysisButton}>
          <Form.Item>
            <Button
              type="button"
              block
              icon={<FontAwesomeIcon icon={faRobot} style={{ marginRight: 5 }} />}
              onClick={onSubmit}
            >
              {t('run_ai_analysis')}
            </Button>
          </Form.Item>
        </If>
      </Form>
    </AIFormContentWrapper>
  )
}
